module.exports = __webpack_public_path__ + "img/banner-one10.89facd15.png";